"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PracticeGroups = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@xstate/react");
const button_1 = require("@kyruus/button");
const tooltip_1 = require("@kyruus/tooltip");
const InfoCircle_1 = __importDefault(require("@kyruus/react-ikons/InfoCircle"));
const ui_theme_1 = require("@kyruus/ui-theme");
const ProviderTabs_styles_1 = require("../../ProviderTabs.styles");
const PracticeGroups_styles_1 = require("./PracticeGroups.styles");
const PracticeGuide_1 = require("../../../PracticeGuide");
const state_1 = require("./state");
const NOOP = () => {
    // no operation
};
const PracticeGroups = (_a) => {
    var _b, _c;
    var { provider: initialProvider, customerCode, productName, labels: { viewGuideLabel = 'View Guide', noGuideLabel = 'No Guide', noGuideTooltipLabel = 'There are no Guides associated with this Practice Group', noPracticeGroupsLabel = 'No Practice Groups Available', practiceGuideLabel = 'Practice Guide', tryAgainLabel = 'Try again?', noContentLabel, alertsSection1Label, alertsSection2Label } = {}, onShowGuide, onActivateGuideTab, onFetchSuccess = NOOP, onFetchError = NOOP } = _a, restProps = __rest(_a, ["provider", "customerCode", "productName", "labels", "onShowGuide", "onActivateGuideTab", "onFetchSuccess", "onFetchError"]);
    const machine = (0, react_1.useMemo)(() => (0, state_1.createGuidesMachine)({
        provider: initialProvider,
        customerCode,
        productName
    }), []);
    const [state, send] = (0, react_2.useMachine)(machine, {
        devTools: true,
        actions: {
            onFetchSuccess,
            onFetchError
        }
    });
    const allPractices = (_b = state.context.provider.practice_groups) !== null && _b !== void 0 ? _b : [];
    const handleShowGuide = (practiceGroup) => {
        send(state_1.GuidesEventType.FETCH_GUIDE, { payload: { id: practiceGroup.id } });
        onShowGuide === null || onShowGuide === void 0 ? void 0 : onShowGuide(practiceGroup);
    };
    const handleHideGuide = () => {
        send(state_1.GuidesEventType.HIDE_GUIDE);
    };
    const showGuide = state.matches(state_1.GuidesStates.SHOW_GUIDE);
    const isLoading = state.matches(state_1.GuidesStates.LOADING_GUIDE);
    const noPracticeGroupsToShow = state.matches(state_1.GuidesStates.NO_PRACTICE_GROUPS);
    const guideError = state.matches(state_1.GuidesStates.LOAD_GUIDE_FAILURE);
    return (react_1.default.createElement(ProviderTabs_styles_1.Content, { "data-testid": "'practiceGroups" },
        react_1.default.createElement(PracticeGroups_styles_1.List, null, noPracticeGroupsToShow ? (react_1.default.createElement(PracticeGroups_styles_1.ListItem, null, noPracticeGroupsLabel)) : (allPractices.map((practice) => {
            const noGuide = !practice.has_info;
            const isActive = !noGuide && practice.id === state.context.activePracticeGuide;
            const handleClick = noGuide
                ? undefined
                : () => {
                    handleShowGuide(practice);
                };
            return (react_1.default.createElement(PracticeGroups_styles_1.ListItem, { key: practice.id },
                noGuide ? (react_1.default.createElement(PracticeGroups_styles_1.NoGuideWrapper, null,
                    react_1.default.createElement(tooltip_1.Tooltip, { title: react_1.default.createElement("span", null, noGuideTooltipLabel), placement: "bottom" },
                        react_1.default.createElement("button", { "aria-label": "toolip trigger element" },
                            react_1.default.createElement(InfoCircle_1.default, { size: (0, ui_theme_1.fromTheme)('font_size_heading_3')(restProps), color: (0, ui_theme_1.fromTheme)('color_info')(restProps), title: '' }))),
                    react_1.default.createElement("span", null,
                        react_1.default.createElement("i", null, noGuideLabel)))) : (react_1.default.createElement(button_1.ButtonWithSpinner, { role: "button", showSpinner: isLoading && isActive, disabled: isLoading || showGuide, mode: "ghost", "aria-label": guideError && isActive
                        ? `${tryAgainLabel} ${viewGuideLabel} ${practice.name}`
                        : `${viewGuideLabel} ${practice.name}`, onClick: handleClick }, guideError && isActive ? tryAgainLabel : viewGuideLabel)),
                react_1.default.createElement("span", null, practice.name)));
        }))),
        react_1.default.createElement(PracticeGuide_1.PracticeGuideDrawer, { title: practiceGuideLabel, labels: { noContentLabel, alertsSection1Label, alertsSection2Label }, open: showGuide, practiceGuide: state.context.activePracticeGuide
                ? (_c = state.context.practiceGuides) === null || _c === void 0 ? void 0 : _c[state.context.activePracticeGuide]
                : undefined, onActivateTab: onActivateGuideTab, onClose: () => {
                handleHideGuide();
            } })));
};
exports.PracticeGroups = PracticeGroups;
//# sourceMappingURL=PracticeGroups.js.map